import React, { useEffect, useState } from 'react';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import { client, consoleLogInDev, track } from 'shared';
import { Colors, SmallIconButton } from 'library';
import { CommentModel, PostModel, ReactionsType } from '../NewsfeedModels';

const ReactionAction = ({
    item,
    itemType,
    reactionType,
    refresh,
}: {
    item: CommentModel | PostModel;
    itemType: 'post' | 'comment';
    reactionType: ReactionsType;
    refresh: () => void;
}) => {
    const [reactionOn, setReactionOn] = useState(false);

    useEffect(() => setReactionOn(!!item.reactions[reactionType].user_reaction_id), [item]);

    const toggleLike = () => {
        track('Newsfeed: Reaction toggle', {
            item: item,
            reaction: reactionType,
            previousReactionState: reactionOn,
            nextReactionState: !reactionOn,
        });
        if (reactionOn) {
            client(`api/user-reaction/${item.reactions[reactionType].user_reaction_id}/`, { method: 'DELETE' })
                .catch(consoleLogInDev)
                .finally(refresh);
        } else {
            type bodyType = { name: ReactionsType; post_id?: number; comment_id?: number };
            let body: bodyType = { name: reactionType };
            body[itemType === 'post' ? 'post_id' : 'comment_id'] = item.id;
            client('api/user-reaction/', { body }).catch(consoleLogInDev).finally(refresh);
        }
    };

    return (
        <SmallIconButton
            color={reactionOn ? Colors.white : Colors.darkNavy}
            backgroundColor={reactionOn ? Colors.darkNavy : Colors.lightGrey}
            onClick={toggleLike}
            icon={ThumbUpIcon}
        />
    );
};

export default ReactionAction;
